export const phoneNumberRegex = /^\+[0-9]*$/;
export const passwordRegex = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[$-/:-?{-~!"^_`[\]@#\\])([a-zA-Z0-9$-/:-?{-~!"^_`[\]@#\\]+){8,}$/